"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spacing = require("./Spacing");

var getClassName = function getClassName(value, placement) {
  var _context;

  return value !== undefined ? (0, _concat.default)(_context = "padding-component--".concat(placement, "-")).call(_context, value) : "";
};
/**
 * @class Padding
 * @desc Flexible component for adding padding. Different from Spacing because padding doesn't collapse.
 * @param {string} [data-id="padding-component"]
 *          To define the base "data-id" value for the top-level HTML container.
 * @param {string} [className]
 *      class name(s) to add to the top-level container/div
 * @param {Spacing.Sizes} bottom
 *      Padding on bottom
 * @param {Spacing.Sizes} left
 *      Padding on left
 * @param {Spacing.Sizes} right
 *      Padding on right
 * @param {Spacing.Sizes} top
 *      Padding on top
 * @param {Spacing.Sizes} vertical
 *      Padding on top and bottom
 * @param {Spacing.Sizes} horizontal
 *      Padding on left and right
 * @param {Spacing.Sizes} padding
 *      Padding on all sides
 */


var makeInlineClass = function makeInlineClass(_ref) {
  var inline = _ref.inline;
  return {
    "padding-component--inline": inline
  };
};

var Padding = (0, _Spacing.makeSpacing)({
  getClassName: getClassName,
  makeCustomClasses: makeInlineClass
});

var paddingPropType = _propTypes.default.oneOf((0, _values.default)(_Spacing.sizes));

Padding.propTypes = {
  bottom: paddingPropType,
  left: paddingPropType,
  right: paddingPropType,
  top: paddingPropType,
  vertical: paddingPropType,
  horizontal: paddingPropType,
  padding: paddingPropType
};
Padding.defaultProps = {
  "data-id": "padding-component"
};
Padding.sizes = _Spacing.sizes;
var _default = Padding;
exports.default = _default;
module.exports = exports["default"];